import { Box, Button, Typography } from "@mui/material";
import history from "../../../../history";
// import NotFoundSvg from "../../../../svg/NotFoundSvg";

const CustomTokenNotFound = ({
  title = "Sorry, Something went wrong!",
  description = "",
  illustration,
  navigateButton = null,
  showButton = true,
  ButtonText = "Back",
  onLoginClick = () => history.push("/"),
}) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "500px",
        }}
      >
        <Typography
          textAlign="center"
          component="h6"
          variant="h4"
          fontWeight={700}
          lineHeight={1}
          mb={2}
        >
          {title}
        </Typography>

        {description && (
          <Typography
            textAlign="center"
            variant="body1"
            color="text.secondary"
          >
            {description}
          </Typography>
        )}

        {illustration && <div style={{ marginBottom: "40px", height: "196px", marginTop: "40px" }}>
          {illustration}
        </div>}

        {navigateButton}

        {showButton && (
          <Button sx={{ mt: 2 }} onClick={onLoginClick}>
            {ButtonText}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default CustomTokenNotFound;